import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["alt"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["alt"]
const _hoisted_4 = ["src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'InlineVideo',
  props: {
	name: {
		type: String,
		required: true,
	},
	alt: {
		type: String
	}
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("video", {
      playsinline: "",
      autoplay: "",
      muted: "",
      loop: "",
      poster: "",
      class: "desktop-only demo",
      alt: __props.alt
    }, [
      _createElementVNode("source", {
        src: require(`@/assets/vid/${__props.name}.mp4`),
        type: "video/mp4"
      }, null, 8, _hoisted_2)
    ], 8, _hoisted_1),
    _createElementVNode("video", {
      playsinline: "",
      autoplay: "",
      muted: "",
      loop: "",
      poster: "",
      class: "mobile-only demo",
      alt: __props.alt
    }, [
      _createElementVNode("source", {
        src: require(`@/assets/vid/${__props.name}-sm.mp4`),
        type: "video/mp4"
      }, null, 8, _hoisted_4)
    ], 8, _hoisted_3)
  ], 64))
}
}

})